module.exports = __webpack_public_path__ + "img/customerLogo4.bcca05ef.png";